/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.adminModule')

/**
 * Filter out all groups/groupMemberships except organizations.
 */
.filter('organizationFilter', function() {
  return function(groups) {
    var organizations = [];
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].type === 'ORGANIZATION') {
        organizations.push(groups[i]);
      }
    }
    return organizations;
  };
});
